import cookie from 'cookie';

export const state = () => ({
  isLayoutReady: false
});

export const mutations = {
  setIsLayoutReady(state, layoutReady) {
    state.isLayoutReady = layoutReady;
  }
};

export const getters = {
  isLayoutReady: state => state.isLayoutReady
};

export const actions = {
  async nuxtServerInit(
    { commit, dispatch, rootState },
    { req, route, redirect, $bugsnag }
  ) {
    if (!process.server || !req?.headers) {
      return;
    }

    const h = req.headers;
    const state = h['cf-region-code'];
    if (state) {
      commit('location/setLocation', {
        state,
        fullState: h['cf-region'],
        city: h['cf-ipcity'],
        country: h['cf-ipcountry'],
        zip: h['cf-postal-code']
      });
    }

    const cookies = req.headers.cookie ? cookie.parse(req.headers.cookie) : {};

    if (cookies['trav:ls'] && !cookies['trav:ssid']) {
      await dispatch('auth/logout');
      return redirect('/login/');
    }

    if (!cookies['trav:ls'] || Object.keys(rootState.auth.currentUser).length) {
      return;
    }

    // Fetch user data and permission when logged in && currentUser is not set
    try {
      await dispatch('auth/fetchUser');

      if (!rootState.auth.currentUser?.id) {
        return redirect('/login/');
      }

      await dispatch('auth/checkUserPermissions');
      await dispatch('report-monitor/fetchReportChangesCount');
      const routesWithMonitorWidget = [
        'dashboard-reports',
        'dashboard-account',
        'dashboard-billing-history',
        'dashboard-subscribe'
      ];
      const hasMonitorWidget = routesWithMonitorWidget.includes(route.name);

      if (hasMonitorWidget) {
        await dispatch('report-monitor/fetchLatestMonitoringUpdates');
      }
    } catch (error) {
      const isAccessDenied =
        error?.message === 'Access Denied' ||
        (typeof error === 'string' && error.includes('Access Denied'));

      if (!isAccessDenied) {
        $bugsnag?.notify(error, event => {
          event.addMetadata('Extra Info', {
            page: 'store/index.js',
            component: 'nuxtServerInit',
            method: 'nuxtServerInit'
          });
        });
      }
      console.error('nuxtServerInit error:', error);

      if (!rootState.auth.currentUser?.id) {
        return redirect('/login/');
      }
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
